<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';

import type { EStaticPageName } from '@modules/static-pages/enums';
import { useLocale } from '@modules/i18n/composables';
import StaticPagePreview from '@modules/static-pages/components/StaticPagePreview/StaticPagePreview.vue';
import useStaticPageConfig from '@modules/static-pages/composables/useStaticPageConfig';
import {
  TRANSLATION_GROUP_STATIC_PAGES,
} from '@modules/static-pages/constants';
import { useStaticPageQuery } from '@modules/static-pages/queries';

const route = useRoute();

const { currentLocale } = useLocale();
const { getStaticPageNameByRoute } = useStaticPageConfig();

const page = computed<EStaticPageName | undefined>(() => getStaticPageNameByRoute(route.name));

const { data, isLoading } = useStaticPageQuery(page, currentLocale);
</script>

<template>
  <StaticPagePreview v-data-qa-auto-id="'StaticPage'"
    :key="page"
    :is-loading="isLoading"
    :last-update-label="$getTranslation(TRANSLATION_GROUP_STATIC_PAGES, `${page}_LAST_UPDATE`)"
    :title="$getTranslation(TRANSLATION_GROUP_STATIC_PAGES, `${page}_HEADER`)"
    :body="data?.content"
    :last-update="data?.updated_at"
  />
</template>
